import { useState } from "react";
import { useTranslation } from "react-i18next";
import { NeuButton } from "../../components/neu/Neu";

const GREEN = { background: "linear-gradient(180deg,#22c55e,#15803d)" };
const RED = { background: "linear-gradient(180deg,#ef4444,#b91c1c)" };

// غطاء ضبابي مركزي بتصميم 3D يُغلق بالنقر على الخلفية (ما لم يكن قيد الإرسال).
const Overlay = ({ testid, onClose, children }) => (
  <div
    className="fixed inset-0 z-[70] flex items-center justify-center bg-black/40 p-4 backdrop-blur-md"
    data-testid={testid}
    onClick={onClose}
  >
    <div className="neu w-full max-w-sm rounded-3xl p-6 text-center" onClick={(e) => e.stopPropagation()}>
      {children}
    </div>
  </div>
);

export const ConfirmAckDialog = ({ busy, onYes, onNo }) => {
  const { t } = useTranslation();
  return (
    <Overlay testid="salary-ack-confirm" onClose={() => !busy && onNo()}>
      <p className="text-base font-black text-primary">{t("salaryAck.confirmQ")}</p>
      <div className="mt-5 flex gap-3">
        <NeuButton variant="primary" style={GREEN} className="flex-1 font-black text-white"
          disabled={busy} data-testid="salary-ack-yes" onClick={onYes}>{t("salaryAck.yes")}</NeuButton>
        <NeuButton className="flex-1 font-black" disabled={busy}
          data-testid="salary-ack-no" onClick={onNo}>{t("salaryAck.no")}</NeuButton>
      </div>
    </Overlay>
  );
};

export const NotReceivedDialog = ({ busy, onSend, onClose }) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState("");
  return (
    <Overlay testid="salary-notreceived-modal" onClose={() => !busy && onClose()}>
      <p className="text-base font-black text-destructive">{t("salaryAck.reasonTitle")}</p>
      <textarea
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        rows={3}
        placeholder={t("salaryAck.reasonPh")}
        data-testid="salary-reason-input"
        className="mt-3 w-full rounded-2xl bg-background p-3 text-sm shadow-neu-in focus:outline-none focus:ring-2 focus:ring-ring"
      />
      <NeuButton variant="primary" style={RED} className="mt-4 w-full font-black text-white"
        disabled={busy || reason.trim().length < 3} data-testid="salary-reason-send"
        onClick={() => onSend(reason.trim())}>{t("salaryAck.send")}</NeuButton>
    </Overlay>
  );
};
